import { combineReducers } from "redux";

import locale from "./reducer/locale";

export default combineReducers({
	locale
});